if (!customElements.get('lp-routine-steps')) {
  class LpRoutineSteps extends HTMLElement {
    connectedCallback() {
      this.scroller = this.querySelector('.lp-video-landing-face-eyes__steps');
      this.dots = Array.from(this.querySelectorAll('.lp-video-landing-face-eyes__dot'));
      this.realSteps = Array.from(
        this.querySelectorAll('.lp-video-landing-face-eyes__step:not(.is-clone)')
      );
      this.allSteps = Array.from(this.querySelectorAll('.lp-video-landing-face-eyes__step'));
      if (!this.scroller || this.realSteps.length < 2) return;

      this.hasClones = this.allSteps.length > this.realSteps.length;
      this.isTeleporting = false;

      // Make sure the carousel is revealed even if the inline init didn't
      // (e.g. if the custom element was upgraded before the inline script
      // for some reason).
      this.classList.add('is-ready');

      this.updateActiveDot();

      let scrollTimeout = null;
      this.scroller.addEventListener(
        'scroll',
        () => {
          if (this.isTeleporting) return;
          this.updateActiveDot();
          if (this.hasClones) {
            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(() => this.handleScrollSettled(), 120);
          }
        },
        { passive: true }
      );
    }

    scrollToStep(step, smooth) {
      if (!step) return;
      const target = step.offsetLeft - (this.scroller.clientWidth - step.offsetWidth) / 2;
      this.scroller.scrollTo({ left: target, behavior: smooth ? 'smooth' : 'auto' });
    }

    getCenteredStepIndex() {
      const steps = this.allSteps;
      const center = this.scroller.scrollLeft + this.scroller.clientWidth / 2;
      let closest = 0;
      let smallestDelta = Infinity;
      steps.forEach((step, i) => {
        const stepCenter = step.offsetLeft + step.offsetWidth / 2;
        const delta = Math.abs(stepCenter - center);
        if (delta < smallestDelta) {
          smallestDelta = delta;
          closest = i;
        }
      });
      return closest;
    }

    updateActiveDot() {
      const centered = this.getCenteredStepIndex();
      const realCount = this.realSteps.length;
      // With a triple-set layout the cards repeat in order, so the real
      // index is simply (centered % realCount). When there are no clones
      // (desktop / single block) this also resolves correctly.
      const realIndex = realCount > 0 ? ((centered % realCount) + realCount) % realCount : 0;
      this.dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === realIndex);
      });
    }

    handleScrollSettled() {
      const realCount = this.realSteps.length;
      const realStart = realCount; // index of first real card
      const realEnd = realCount * 2 - 1; // index of last real card
      const centered = this.getCenteredStepIndex();
      // If the centered card lives in the leading or trailing clone set,
      // jump (no animation) to the matching real card so the user always
      // has a full set of clones to scroll into next.
      if (centered < realStart) {
        this.teleportToStep(this.allSteps[centered + realCount]);
      } else if (centered > realEnd) {
        this.teleportToStep(this.allSteps[centered - realCount]);
      }
    }

    teleportToStep(step) {
      this.isTeleporting = true;
      this.scrollToStep(step, false);
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.isTeleporting = false;
          this.updateActiveDot();
        });
      });
    }
  }
  customElements.define('lp-routine-steps', LpRoutineSteps);
}
